import { useState, type FormEvent } from 'react';
import { useLang } from '@/app/hooks/useLang';

const FORM_NAME = 'advance-clearance';

export function ClearanceForm() {
  const { t } = useLang();
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'pending' | 'ok' | 'error'>('idle');

  const handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const nextEmail = email.trim();
    if (!nextEmail) {
      setStatus('error');
      return;
    }

    setStatus('pending');
    try {
      if (import.meta.env.DEV) {
        const response = await fetch('/api/subscribe', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ email: nextEmail, source: FORM_NAME }),
        });
        if (!response.ok) throw new Error('subscribe failed');
      } else {
        const body = new URLSearchParams({
          'form-name': FORM_NAME,
          email: nextEmail,
          'bot-field': '',
        });
        const response = await fetch('/', {
          method: 'POST',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
          body: body.toString(),
        });
        if (!response.ok) throw new Error('clearance failed');
      }
      setEmail('');
      setStatus('ok');
    } catch {
      setStatus('error');
    }
  };

  return (
    <form
      name={FORM_NAME}
      method="POST"
      action="/"
      className="space-y-2"
      onSubmit={handleSubmit}
    >
      <input type="hidden" name="form-name" value={FORM_NAME} />
      <p className="hidden">
        <label>
          Don’t fill this out: <input name="bot-field" />
        </label>
      </p>
      <label htmlFor="advance-clearance-email" className="doc-field-label">
        {t('clearance.email')}
      </label>
      <div className="flex flex-col items-start gap-2">
        <input
          id="advance-clearance-email"
          name="email"
          type="email"
          required
          autoComplete="email"
          value={email}
          onChange={(event) => setEmail(event.target.value)}
          className="term-field"
          placeholder={t('clearance.emailPlaceholder')}
        />
        <button
          type="submit"
          disabled={status === 'pending'}
          className="tab-control action-btn disabled:opacity-60"
        >
          [ {t('clearance.action')} ]
        </button>
      </div>
      <p className="dim text-sm">{t('clearance.plain')}</p>
      {status === 'ok' && <p className="text-sm">{t('clearance.success')}</p>}
      {status === 'error' && <p className="bright text-sm">{t('clearance.error')}</p>}
    </form>
  );
}
